import { Box } from '@mui/material';
import { DealForm } from 'components/featured/Deals/components/DealForm';
import { useLocation } from 'react-router-dom';

const DealNew = () => {
  const location = useLocation();
  const presetClient = (location.state as any)?.presetClient;
  const lockClient = Boolean((location.state as any)?.lockClient);

  return (
    <Box sx={{ height: 'calc(100vh - 160px)' }}>
      <DealForm isEdit={false} presetClient={presetClient} lockClient={lockClient} />
    </Box>
  );
};

export default DealNew;
